import { IconButton, Tooltip } from "@evergis/ui";
import React, { FC } from "react";
import { DateFormat, formatDate } from "../../../../../../utils/date";
import { JSONAttributeValue } from "../../types";
import { FileImagePreview } from "./FileImagePreview";
import { getFileType } from "./getFileType";
import { AttachmentsDate, GridActions, GridIcon, GridItemContainer, GridItemOverlay } from "./styled";
import { IMAGE_FILE_TYPES } from "./types";

export interface AttachmentGridItemProps {
  item: JSONAttributeValue;
  onPreview: (name: string) => void;
  onDelete: (name: string) => void;
  isEdit: boolean;
}

export const AttachmentGridItem: FC<AttachmentGridItemProps> = ({ item, isEdit, onPreview, onDelete }) => {
  const { mimeType, link, isExternal, name: fileName, date } = item;
  const fileType = getFileType(mimeType, fileName);
  const isImg = IMAGE_FILE_TYPES.includes(fileType);

  return (
    <Tooltip
      key={link}
      content={
        <div>
          <div>{fileName}</div>
          {date && <AttachmentsDate>{formatDate(date, { dateFormat: DateFormat.DateTime })}</AttachmentsDate>}
        </div>
      }
      placement="top"
      arrow
      delay={0.5}
    >
      {ref => (
        <GridItemContainer onClick={() => onPreview(fileName)} ref={ref}>
          {!isImg && <GridIcon fileType={fileType} />}
          {isImg && <FileImagePreview isExternal={isExternal} link={link} />}
          {isEdit && (
            <GridActions onClick={event => event.stopPropagation()}>
              <IconButton kind={"delete"} onClick={() => onDelete(link)} />
            </GridActions>
          )}
          <GridItemOverlay />
        </GridItemContainer>
      )}
    </Tooltip>
  );
};
